import type { TrpcRouterType } from '@pushflow/server/src/router/types'
import { retrieveLaunchParams } from '@telegram-apps/sdk-react'
import { createTRPCReact, httpBatchLink } from '@trpc/react-query'

export const trpc = createTRPCReact<TrpcRouterType>()

export const createTrpcClient = () =>
  trpc.createClient({
    links: [
      httpBatchLink({
        url: `${import.meta.env.VITE_API_URL}/trpc`,
        headers: () => {
          try {
            const { initDataRaw } = retrieveLaunchParams()
            return { Authorization: `tma ${initDataRaw}` }
          } catch {
            return {}
          }
        },
      }),
    ],
  })
